import { ApiCommonParams } from "../../@types/apiTypes";
import { ApiResponse } from "../../apiResponse";
import Axios from "../../axios";
import { commonApiParamsToApiParams } from "../../helpers/paramsHelpers";

export function indexCredits(
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get(`v1/tutors/credits`, { params: params });
}
